export function authHeader() {
  // 
  let user = JSON.parse(localStorage.getItem("userDetails"));
  // console.log("getuser", user)
  if (user && user.accessToken) {
    // 
    // console.log("getuser123", user.accessToken)
    return {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + user.accessToken,
      // "Access-Control-Allow-Origin": "*"
    };
  } else {
    // return {};
  }
}